// Reusable empty state component for list pages
// CREATED: Centralizes the empty state pattern used across admin pages (Users, Sites, Services, Incidents, Missions)
// Props: message (required), optional actionLabel + onAction for reset button, optional icon

import { ReactNode } from 'react';

interface EmptyStateProps {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: ReactNode;
}

export function EmptyState({ message, actionLabel, onAction, icon }: EmptyStateProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 px-6 py-12 text-center">
      {icon && (
        <div className="flex justify-center mb-3">
          {icon}
        </div>
      )}
      <div className="text-gray-500">{message}</div>
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="mt-2 text-sm text-primary-600 hover:text-primary-700 font-medium"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}
